import { useQuery } from '@tanstack/react-query';
import useAPI from 'services/useAPI';

// general structure of the query keys that should probably work for most cases
export const assetKeys = {
  all: ['assets'],
  assets: () => [...assetKeys.all],
  asset: (id) => [...assetKeys.assets(), id]
};

export const useAssetQuery = (assetId) => {
  const api = useAPI();
  const query = useQuery({
    queryKey: assetKeys.asset(assetId),
    queryFn: ({ signal }) => {
      if (assetId) {
        return api.core.getAsset(signal, assetId);
      }
      return null;
    }
  });
  return query;
};


export const assetsAndProvidersKeys = {
  all: ['assets_and_providers'],
  assetsAndProviders: (assetId) => [...assetsAndProvidersKeys.all, assetId]
};

export const useAssetsAndProvidersQuery = (assetId) => {
  const api = useAPI();
  const query = useQuery({
    queryKey: assetsAndProvidersKeys.assetsAndProviders(assetId),
    queryFn: ({ signal }) => {
      if (assetId) {
        return api.core.getAssetAndProviders(signal, assetId);
      }
      return null;
    }
  });
  return query;
};


